export const userKeys = {
  all: ['users'] as const,
  lists: () => [...userKeys.all, 'list'] as const,
  list: (companyId: string) => [...userKeys.lists(), companyId] as const,
  details: () => [...userKeys.all, 'detail'] as const,
  detail: (id: string) => [...userKeys.details(), id] as const,
  byCompany: (companyId: string) => ['users', 'byCompany', companyId] as const,
}
